import React from "react";

const ArrowForward = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="10" fill="none">
    <path fill="currentColor" fillOpacity=".68" d="M1.076 5.424a.6.6 0 010-.848L4.894.757a.6.6 0 01.849.849L2.349 5l3.394 3.394a.6.6 0 11-.849.849L1.076 5.424zM17.5 5.6h-16V4.4h16v1.2z" />
  </svg>
);

export default ArrowForward;
